const SkipLink = () => (
  <a className="skip-link" href="#main-content">
    Skip to main content
  </a>
);

export default SkipLink;
